module.exports = __webpack_public_path__ + "static/media/eye_hide.98ffe51d.svg";